import { useTheme } from '@repo/themes';
import { ContactInfo } from '@repo/utils/types';
import sourceIconPaths from '@repo/utils/helpers/source-icon-paths';

type AssetPath = string;

interface ThemedIconForSourceOpts {
  baseIconOnIntegration?: boolean;
}

export const useThemedIconForSource = (
  source: ContactInfo,
  { baseIconOnIntegration }: ThemedIconForSourceOpts = {},
): AssetPath | undefined => {
  const [theme] = useTheme();
  let iconKey: string = source.type;

  if (baseIconOnIntegration) {
    switch (source.source) {
      case 'CL':
        iconKey = 'calendar';
        break;
      case 'TW':
        iconKey = 'twitter';
        break;
      case 'FB':
        iconKey = 'facebook';
        break;
      case 'LI':
        iconKey = 'linkedin';
        break;
      case 'ME':
      case 'EM':
        iconKey = 'email';
        break;
      case 'MA':
      case 'BI':
      case 'SS':
        iconKey = 'manual';
        break;
      case 'IG':
        iconKey = 'instagram';
        break;
    }

    if (source.type === 'phone') {
      iconKey = 'phone';
    }

    if (source.type === 'messages') {
      iconKey = 'messages';
    }

    if (source.type === 'email' && !iconKey) {
      iconKey = 'email';
    }
  }

  if (!iconKey) {
    return undefined;
  }

  return sourceIconPaths[`${iconKey}_${theme}`] || sourceIconPaths[iconKey];
};
